import React from "react";
import CinematicHero from "@/components/CinematicHero";

/**
 * Anteprima cinematic hero — pagina pubblica per testare l'effetto
 * con foto demo (assets landing già presenti). Nessuna auth richiesta.
 *
 * URL: /cinematic-preview
 */
export default function CinematicPreview() {
  // 6 foto demo (le migliori dei landing assets)
  const photos = [
    "/landing/sala-original-after.jpg",
    "/landing/cucina-after.jpg",
    "/landing/camera-after.jpg",
    "/landing/bagno-after.jpg",
    "/landing/rinnova-after.jpg",
    "/landing/esterno-after.jpg",
  ];

  return (
    <div className="bg-[#0E0E0C] min-h-screen">
      <CinematicHero
        photos={photos}
        title="Trilocale ristrutturato"
        location="Brera · Milano"
        agencyName="Ada Verzi Immobili"
        height="h-screen"
      />
    </div>
  );
}
